export default {"src":"/_next/static/media/TikTok.0331db51.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};